import { Control, FieldValues, Path } from 'react-hook-form';
import { QUERY_KEYS } from '../../constants';
import { Customer } from '../../@types/api';
import FormAutocomplete, { AutocompleteItem, FormAutocompleteProps } from '../organisms/FormAutocomplete';
import { getCompleteName } from '../../utils';

const defaultGetOptionLabel = (options: Customer[], value: string) => {
  const option = options.find((option) => option.userId === value);
  return option ? `${getCompleteName(option.firstName, option.lastName, option.username)}` : '';
};

type Props<
  O extends AutocompleteItem,
  T extends FieldValues,
  TTransformedValues extends FieldValues | undefined = T,
> = Partial<FormAutocompleteProps<O, T, TTransformedValues>> & {
  control: Control<T, unknown, TTransformedValues>;
  name: Path<T>;
  multipleSelect?: boolean;
};

const CustomerSelect = <T extends FieldValues, TTransformedValues extends FieldValues | undefined = T>({
  control,
  name,
  label = 'Players',
  queryKey = [QUERY_KEYS.customers],
  url = 'customer/search',
  getOptionLabel = defaultGetOptionLabel,
  multipleSelect = true,
  ...rest
}: Props<Customer, T, TTransformedValues>) => {
  return (
    <FormAutocomplete<Customer, T, TTransformedValues>
      name={name}
      control={control}
      label={label}
      getOptionLabel={getOptionLabel}
      url={url}
      queryKey={queryKey}
      apiService='crm'
      optionsFilter='userId'
      multiple={multipleSelect}
      {...rest}
    />
  );
};

export default CustomerSelect;
